import * as React from "react";
const SvgFiBrandsPatreon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      fill="#151A2D"
      fillRule="evenodd"
      clipPath="url(#fi-brands-patreon_svg__a)"
      clipRule="evenodd"
    >
      <path d="M15.385.48c-4.765 0-8.641 3.88-8.641 8.65 0 4.755 3.877 8.624 8.641 8.624 4.75 0 8.615-3.869 8.615-8.624C24 4.36 20.136.48 15.385.48M0 23.52h4.219V.48H0z" />
    </g>
    <defs>
      <clipPath id="fi-brands-patreon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsPatreon;
